import { createApi } from '@reduxjs/toolkit/query/react';
import { format } from 'url';

import { TagTypesEnum } from '@enum/tag-types.enum';
import { EventLogResponseInterface, LogFilterInterface, RequestInterface } from '@interface/logs/logs.interface';
import { PaginationRequestInterface, ResponseDataInterface } from '@interface/logs/response-data.interface';
import { apiQueryAuth } from '@util/api/api-query-auth';
import { queryBuilder } from '@util/api/query-builder';

export const logsConsumerApi = createApi({
  reducerPath: 'logs-consumer-api',
  tagTypes: [TagTypesEnum.ConsumerRequest, TagTypesEnum.ConsumerEvents],
  baseQuery: apiQueryAuth('/'),
  endpoints: (build) => ({
    loadRequests: build.query<
      ResponseDataInterface<RequestInterface[]>,
      (PaginationRequestInterface & LogFilterInterface) | void
    >({
      query: (params: (PaginationRequestInterface & LogFilterInterface) | void = {}) => {
        const { pagination, filter } = params || {};
        return format({ pathname: '/requests/consumer-requests', query: queryBuilder({ ...pagination, ...filter }) });
      },
      providesTags: [TagTypesEnum.ConsumerRequest],
    }),
    loadEvents: build.query<
      ResponseDataInterface<EventLogResponseInterface[]>,
      (PaginationRequestInterface & LogFilterInterface) | void
    >({
      query: (params: (PaginationRequestInterface & LogFilterInterface) | void = {}) => {
        const { pagination, filter } = params || {};
        return format({ pathname: '/events', query: queryBuilder({ ...pagination, ...filter }) });
      },
    }),
  }),
});
